var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_505_48224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#036068",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_505_48224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72455 16.1202H5.80469V13.2003L13.6745 5.33048C13.9433 5.06172 14.379 5.06172 14.6478 5.33048L16.5944 7.27706C16.8631 7.54582 16.8631 7.98158 16.5944 8.25034L8.72455 16.1202ZM5.80469 17.4966H18.1926V18.873H5.80469V17.4966Z",
    fill: "url(#paint0_linear_505_48224)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_505_48224",
    x: -27.6,
    y: -27.6,
    width: 79.2,
    height: 79.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_505_48224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_505_48224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_505_48224",
    x: -21.7953,
    y: -22.4711,
    width: 67.5867,
    height: 68.9441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_505_48224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_505_48224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_505_48224",
    x1: 19.9661,
    y1: 18.873,
    x2: -0.111439,
    y2: 18.8175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1E7C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#4C7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.087a5271e497e074c33eab2666345641.svg";
export { ForwardRef as ReactComponent };